import clients from './clients'

export default {
  manager: {
    namespaced: true,
    modules: {
      clients
    }
  }
}
